/* Basmati theme · global.js */
(function () {
  'use strict';

  /* Digit localisation: on Arabic pages every number becomes Arabic-Indic (٠-٩),
     on English pages every number becomes Western (0-9). Keeps each language consistent. */
  var AR = (document.documentElement.getAttribute('lang') || '').slice(0, 2) === 'ar';
  var W = '0123456789', A = '٠١٢٣٤٥٦٧٨٩';
  function toAr(v) {
    return AR ? String(v).replace(/[0-9]/g, function (d) { return A[+d]; }) : String(v);
  }
  function convTok(tok) {
    if (/[A-Za-z@]/.test(tok) || tok.indexOf('/') > -1) return tok;   /* leave codes, handles, urls */
    return AR
      ? tok.replace(/[0-9]/g, function (d) { return A[+d]; })
      : tok.replace(/[٠-٩]/g, function (d) { return W[A.indexOf(d)]; });
  }
  function initArabicDigits() {
    if (!document.createTreeWalker) return;
    var SKIP = { INPUT: 1, TEXTAREA: 1, SELECT: 1, SCRIPT: 1, STYLE: 1, CODE: 1, NOSCRIPT: 1 };
    function allowed(node) {
      for (var el = node.parentNode; el && el !== document.documentElement; el = el.parentNode) {
        if (el.nodeType !== 1) continue;
        if (SKIP[el.tagName]) return false;
        if (el.hasAttribute && el.hasAttribute('data-no-ar')) return false;
        if (el.classList && el.classList.contains('crumb')) return false;
        if (el.tagName === 'H1' && el.parentNode && el.parentNode.classList && el.parentNode.classList.contains('pdp-info')) return false;
      }
      return true;
    }
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), list = [], n;
    while ((n = tw.nextNode())) { if (/[0-9٠-٩]/.test(n.nodeValue) && allowed(n)) list.push(n); }
    list.forEach(function (node) { node.nodeValue = node.nodeValue.replace(/\S*[0-9٠-٩]\S*/g, convTok); });
  }

  /* reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.rv');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* mobile menu */
  function initMenu() {
    var btn = document.querySelector('.menu-toggle');
    var nav = document.querySelector('.mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () { nav.classList.toggle('open'); });
  }

  /* before/after slider */
  function initBASlider() {
    document.querySelectorAll('.baslider').forEach(function (s) {
      var top = s.querySelector('.ba-top-img');
      var handle = s.querySelector('.ba-handle');
      if (!top) return;
      var drag = false, userTouched = false;
      function apply(p) {
        top.style.clipPath = 'inset(0 ' + ((1 - p) * 100) + '% 0 0)';
        if (handle) handle.style.left = (p * 100) + '%';
      }
      function setP(clientX) {
        var r = s.getBoundingClientRect();
        apply(Math.max(0, Math.min(1, (clientX - r.left) / r.width)));
      }
      s.addEventListener('pointerdown', function (e) { drag = true; userTouched = true; setP(e.clientX); });
      window.addEventListener('pointerup', function () { drag = false; });
      window.addEventListener('pointermove', function (e) { if (drag) setP(e.clientX); });
      /* auto-tease: rock the handle until the visitor grabs it */
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (s.getAttribute('data-tease') === 'true' && !reduced) {
        var t = 0;
        (function tease() {
          if (userTouched) return;
          t += 0.016;
          apply(0.5 + Math.sin(t * 1.4) * 0.09);
          requestAnimationFrame(tease);
        })();
      }
    });
  }

  /* PDP gallery */
  function initGallery() {
    var main = document.querySelector('.gallery .main');
    if (!main) return;
    var mainImg = main.querySelector('img');
    document.querySelectorAll('.thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (!img) return;
        mainImg.src = img.getAttribute('data-full') || img.src;
        mainImg.alt = img.alt || '';
        main.classList.toggle('dark', btn.classList.contains('dark'));
        document.querySelectorAll('.thumbs button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* quantity steppers */
  function initQty() {
    document.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('input');
      if (!input) return;
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n += (b.getAttribute('data-step') === '-') ? -1 : 1;
          var mn = parseInt(input.min, 10); if (isNaN(mn)) mn = 1;
          if (n < mn) n = mn;
          input.value = n;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* sticky add-to-cart on product pages */
  function initStickyATC() {
    var bar = document.querySelector('.sticky-atc');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting;
        bar.classList.toggle('show', show);
        document.body.classList.toggle('atc-visible', show);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var btn = bar.querySelector('[data-sticky-buy]');
    if (btn) btn.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }


  /* buy now: add current form to cart, go to the cart page */
  function initBuyNow() {
    var btn = document.querySelector('[data-buy-now]');
    var form = document.querySelector('form[data-product-form]');
    if (!btn || !form) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = '...';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw 0;
          var cfgB = window.__cartCfg || {};
          if (cfgB.type !== 'page' && window.__renderCart) {
            return fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (c) {
              window.__renderCart(c); window.__openCart();
              btn.disabled = false; btn.textContent = label;
            });
          }
          window.location.href = '/cart';
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  /* countdown timers (fixed date, or evergreen rolling window per visitor) */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var eg = parseInt(el.getAttribute('data-evergreen') || '0', 10);
      var end;
      if (eg > 0) {
        var key = 'bsmti_cd_' + (el.id || (el.getAttribute('data-countdown') || 'x')).slice(0, 12);
        var now = Date.now();
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
        if (!stored || stored < now) { stored = now + eg * 3600 * 1000; try { localStorage.setItem(key, stored); } catch (e) {} }
        end = stored;
      } else {
        end = new Date(el.getAttribute('data-countdown')).getTime();
      }
      if (isNaN(end)) return;
      var cells = {
        d: el.querySelector('[data-t="d"]'), h: el.querySelector('[data-t="h"]'),
        m: el.querySelector('[data-t="m"]'), s: el.querySelector('[data-t="s"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        if (cells.d) cells.d.textContent = toAr(pad(d));
        if (cells.h) cells.h.textContent = toAr(pad(h));
        if (cells.m) cells.m.textContent = toAr(pad(m));
        if (cells.s) cells.s.textContent = toAr(pad(s));
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* AJAX add-to-cart (keeps shopper on page, updates header count) */
  function initAjaxCart() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var orig = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('.cart-link .dot').forEach(function (d) { d.textContent = toAr(cart.item_count); });
            if (btn) { btn.innerHTML = btn.getAttribute('data-added-text') || '✓'; setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1400); }
            var cfgA = window.__cartCfg || {};
            if (cfgA.type === 'page') { window.location.href = '/cart'; return; }
            if (window.__renderCart) { window.__renderCart(cart); window.__openCart(); }  /* slide the cart open */
          })
          .catch(function () { if (btn) { btn.innerHTML = orig; btn.disabled = false; } form.submit(); });
      });
    });
  }

  /* variant change: sync price, sticky bar and button state */
  function initVariantSync() {
    var form = document.querySelector('form[data-product-form]');
    var dataEl = document.querySelector('[data-variant-json]');
    if (!form || !dataEl) return;
    var select = form.querySelector('select[name="id"]');
    if (!select) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });
    select.addEventListener('change', function () {
      var v = byId[select.value];
      if (!v) return;
      var now = document.querySelector('.pdp-price .now');
      var was = document.querySelector('.pdp-price .was');
      var sPrice = document.querySelector('.sticky-atc .s-price');
      if (now) now.textContent = toAr(v.price);
      if (was) { if (v.compare) { was.textContent = toAr(v.compare); was.style.display = ''; } else { was.style.display = 'none'; } }
      if (sPrice) sPrice.textContent = toAr(v.price);
      [form.querySelector('[type="submit"]'), document.querySelector('[data-sticky-buy]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !v.available;
        var label = v.available ? btn.getAttribute('data-atc-label') : btn.getAttribute('data-soldout-label');
        if (label) btn.textContent = label;
      });
    });
  }

  /* money: clean no-decimals amount + currency label, matching the storefront (e.g. "49,000 IQD") */
  function formatMoney(cents) {
    var fmt = window.__mf || '{{amount}} IQD';
    var cur = fmt.replace(/\{\{\s*\w+\s*\}\}0?/, '').trim() || 'IQD';
    var amt = Math.round((cents || 0) / 100);
    var s = String(amt).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return cur ? (s + ' ' + cur) : s;
  }

  /* slide-out cart drawer: open on cart icon click and on every add-to-cart */
  function initCartDrawer() {
    var drawer = document.getElementById('cartDrawer'), overlay = document.getElementById('cartOverlay');
    if (!drawer || !overlay) return;
    function open() { drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    window.__openCart = open; window.__closeCart = close;
    var cont = (window.__shopUrls && window.__shopUrls.cont) || '/collections/all';
    function render(cart) {
      document.querySelectorAll('.cart-link .dot').forEach(function (d) { d.textContent = toAr(cart.item_count); });
      var body = document.getElementById('cdBody'), foot = document.getElementById('cdFoot');
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cd-empty">' + (AR ? 'سلتك فارغة' : 'Your cart is empty') + '</div>';
        foot.innerHTML = '<a class="btn btn--block" href="' + cont + '">' + (AR ? 'كمّل تسوق' : 'Continue shopping') + '</a>';
        return;
      }
      var timerHtml = '';
      if (cdCfg.timer && cdCfg.timerText) timerHtml = '<div class="cd-timer">🔥 <span>' + cdCfg.timerText + '</span> <b data-cd-clock></b></div>';
      body.innerHTML = timerHtml + cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.(?:png|jpg|jpeg|webp|gif))(\?.*)?$/i, '_120x$1$2') : '';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-var">' + it.variant_title + '</div>' : '';
        return '<div class="cd-item"><img src="' + img + '" alt="" loading="lazy"><div class="cd-mid"><div class="cd-name">' + it.product_title + '</div>' + vt +
          '<div class="cd-qty"><button type="button" data-cd-chg="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + toAr(it.quantity) + '</span><button type="button" data-cd-chg="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
          '<div class="cd-price"><span>' + toAr(formatMoney(it.final_line_price)) + '</span><button type="button" class="cd-remove" data-cd-chg="' + it.key + '" data-q="0">' + (AR ? 'احذف' : 'Remove') + '</button></div></div>';
      }).join('');
      if (cdCfg.xs && cdCfg.xs.length && cdCfg.xsLimit) {
        var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
        var xs = cdCfg.xs.filter(function (p) { return !inCart[p.pid]; }).slice(0, cdCfg.xsLimit);
        if (xs.length) {
          body.innerHTML += '<div class="cd-xs">' + (cdCfg.xsTitle ? '<div class="cd-xs-title">' + cdCfg.xsTitle + '</div>' : '') +
            xs.map(function (p) {
              var cp = p.cp && p.cp > p.p ? ' <s>' + toAr(formatMoney(p.cp)) + '</s>' : '';
              return '<div class="cd-xs-item">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') +
                '<div class="cd-xs-mid"><a class="cd-xs-name" href="' + p.url + '">' + p.t + '</a><div class="cd-xs-price">' + toAr(formatMoney(p.p)) + cp + '</div></div>' +
                '<button type="button" class="cd-xs-add" data-cd-xsadd="' + p.vid + '">' + (cdCfg.xsBtn || '+') + '</button></div>';
            }).join('') + '</div>';
        }
      }
      if (cdCfg.timer) startCdTimer(cdCfg.timerMins || 10);
      foot.innerHTML = '<div class="cd-total"><span>' + (AR ? 'المجموع' : 'Total') + '</span><span>' + toAr(formatMoney(cart.total_price)) + '</span></div>' +
        '<a class="btn btn--block" href="/checkout">' + (AR ? 'إتمام الطلب' : 'Checkout') + '</a>' +
        '<a class="cd-cont" href="' + cont + '">' + (AR ? 'كمّل تسوق' : 'Continue shopping') + '</a>';
      if (cdCfg.trust) foot.innerHTML += '<div class="cd-trust">' + cdCfg.trust + '</div>';
    }
    window.__renderCart = render;
    var cdTimerOn = false;
    function startCdTimer(mins) {
      if (cdTimerOn) return; cdTimerOn = true;
      var KEY = 'bas_cart_hold';
      function tick() {
        var el = document.querySelector('[data-cd-clock]'); if (!el) return;
        var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
        if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem(KEY, String(end)); }
        var left = end - Date.now();
        var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
        el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }
      tick(); setInterval(tick, 1000);
    }
    function change(key, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render).catch(function () {});
    }
    var cdCfg = window.__cartCfg || {};
    if (cdCfg.type !== 'page') {
      document.querySelectorAll('.cart-link').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); open(); }); });
      });
    }
    overlay.addEventListener('click', close);
    var xb = drawer.querySelector('[data-cd-close]'); if (xb) xb.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    drawer.addEventListener('click', function (e) {
      var xa = e.target.closest && e.target.closest('[data-cd-xsadd]');
      if (xa) {
        xa.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(xa.getAttribute('data-cd-xsadd'), 10), quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { xa.disabled = false; });
        return;
      }
      var b = e.target.closest && e.target.closest('[data-cd-chg]'); if (!b) return;
      change(b.getAttribute('data-cd-chg'), parseInt(b.getAttribute('data-q'), 10));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initMenu(); initBASlider(); initBuyNow(); initGallery(); initQty(); initStickyATC(); initCountdown(); initCartDrawer(); initAjaxCart(); initVariantSync(); initArabicDigits();
  });
})();

/* ---- Meta AddToCart tracking (added 22 Aug 2026) ----------------------
   The theme adds to cart with a raw fetch to /cart/add.js, which Shopify
   does not instrument, so the Meta web pixel never receives AddToCart.
   This wraps fetch once and fires the event on every successful cart add,
   covering the product form, Buy Now and the cart-drawer cross-sell.
   It never alters the response or the promise the caller receives. */
(function () {
  try {
    var PIXEL = '3002612503423743';
    return; /* disabled 31 Oct 2026: duplicate of Shopify Meta app */
    window.__metaAtcHooked = true;

    function fire(p) {
      try {
        var q = 'id=' + PIXEL + '&ev=AddToCart&noscript=1&dl=' + encodeURIComponent(location.href);
        for (var k in p) { if (p[k] !== undefined && p[k] !== null && p[k] !== '') q += '&cd%5B' + k + '%5D=' + encodeURIComponent(p[k]); }
        (new Image()).src = 'https://www.facebook.com/tr?' + q;
      } catch (e) {}
    }

    var orig = window.fetch;
    window.fetch = function (u, o) {
      var res = orig.apply(this, arguments);
      try {
        var url = (u && u.url) || u || '';
        if (String(url).indexOf('/cart/add') > -1) {
          res.then(function (r) {
            try {
              if (!r || !r.ok) return;
              r.clone().json().then(function (d) {
                var it = (d && d.items && d.items[0]) || d || {};
                var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'IQD';
                var val = (it.final_line_price != null) ? it.final_line_price / 100
                        : (it.price != null ? it.price / 100 : undefined);
                fire({ content_ids: it.product_id || it.id, content_type: 'product',
                       content_name: it.product_title || it.title, value: val, currency: cur });
              }).catch(function () { fire({ content_type: 'product' }); });
            } catch (e) {}
          }).catch(function () {});
        }
      } catch (e) {}
      return res;
    };
  } catch (e) {}
})();
